import { useEffect } from 'react';
import { sessionChannel, handleSessionMessage } from '@packages/shared/session';
import { useBoolean } from '@/hooks';
import { usePermissionGuard } from './usePermissionGuard';

/**
 * Listens for cross-tab logout events via BroadcastChannel.
 * When another tab logs out, opens the logout modal and delegates
 * the UI flow to usePermissionGuard.
 */
export function useCrossTabLogout(): void {
  const {
    value: isLogoutModalOpen,
    setTrue: openLogoutModal,
    setFalse: closeLogoutModal,
  } = useBoolean(false);

  useEffect(() => {
    const handler = (event: MessageEvent) => {
      const type = handleSessionMessage(event);
      if (type === 'logout_event') {
        openLogoutModal();
      }
    };
    sessionChannel.addEventListener('message', handler);
    return () => sessionChannel.removeEventListener('message', handler);
  }, []);

  usePermissionGuard({ isLogoutModalOpen, closeLogoutModal });
}
